<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-06-18 13:23:34
 * @LastEditTime : 2025-07-10 16:30:16
 * @LastEditors  : yangxr
 * @Description  : 供应商台账
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\supplierLedger.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <div class="search">
                        <span style="display: inline-block; margin-bottom: 10px">
                            <span style="margin-right: 12px">主体</span>
                            <el-select ref="companyId" v-model="tableParams.companyId" style="width: 200px" filterable
                                @change="$nextTick(() => { tableParams.companyName = $refs.companyId.selectedLabel })">
                                <el-option v-for="item in mainBodyList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>

                        </span>
                        <span style="margin-left: 24px">
                            <span style="margin-right: 12px">到账时间</span>
                            <el-date-picker v-model="tableParams.accountDate" style="width: 150px;" type="month"
                                unlink-panels value-format="yyyy-MM" start-placeholder="开始时间" end-placeholder="结束时间"
                                @change="querySupplierAmountShare"></el-date-picker>
                        </span>
                        <el-button style="margin-left: 24px" icon="el-icon-search" size="medium" class="bottom_all"
                            @click="querySupplierAmountShare()">查 询</el-button>
                        <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                            置</el-button>
                        <el-button icon="el-icon-plus" size="medium" class="bottom_all"
                            style=" position: absolute;right: 50px;" :disabled="dataType ==3" @click="addForm(1)">添加</el-button>
                    </div>
                    <div class="hr"></div>
                    <div v-loading="tableLoading" :style="style">
                        <el-table ref="tableData1" :header-cell-style="{ background: '#f3f6f9' }"
                            :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%"
                            :height="(screenHeight - 306) / 2" :data="tableDataA" show-overflow-tooltip
                            tooltip-effect="dark" current-row-key="id" show-summary :summary-method="getSummaries">
                            <template v-for="(item, index2) in tableA">
                                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                    :width="item.width" :prop="item.prop" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="item.label == '操作'">
                                            <el-link :underline="false" type="success" :disabled="dataType ==3" 
                                                @click="editForm(scope.row, 1)">编辑</el-link>
                                        </span>
                                        <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>
                        <!-- 第二个表格 -->
                        <div style="height:40px;margin-top: 6px;">
                            <el-button icon="el-icon-plus" size="medium" class="bottom_all"
                                style=" position: absolute;right: 50px;" :disabled="dataType ==3"  @click="addForm(2)">添加</el-button>
                        </div>
                        <el-table ref="tableData2" :header-cell-style="{ background: '#f3f6f9' }"
                            :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%"
                            :height="(screenHeight - 306) / 2" :data="tableDataB" show-overflow-tooltip
                            tooltip-effect="dark" current-row-key="id" show-summary :summary-method="getSummaries">
                            <template v-for="(item, index2) in tableB">
                                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                    :width="item.width" :prop="item.prop" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="item.label == '操作'">
                                            <el-link :underline="false" type="success" :disabled="dataType ==3" 
                                                @click="editForm(scope.row, 2)">编辑</el-link>
                                        </span>
                                        <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>
                    </div>
                </div>
            </el-main>
        </el-container>
        <!-- 添加 -->
        <el-dialog :visible.sync="addDig" width="780px" :close-on-click-modal="false" @close="closeAdd">
            <span slot="title" class="dialog-title">{{ formData.id ? '添加' : '编辑' }}</span>
            <div v-loading="saveload" class="dialoginfo">
                <el-form ref="formData" :rules="formRules" :inline="true" :model="formData" label-width="110px">
                    <el-form-item prop="supplyId">
                        <span slot="label">供应商</span>
                        <el-select ref="supplyId" v-model="formData.supplyId" style="width: 215px" placeholder="请选择"
                            filterable @change="
                                $nextTick(() => {
                                    formData.supplyName = $refs.supplyId.selectedLabel;
                                })
                                ">
                            <el-option v-for="item in supplierList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <div>
                    <el-form-item prop="detailSupplyName">
                        <span slot="label">明细供应商</span>
                        <el-link v-if="!formData.detailSupplyName" :underline="false" type="success"  style="width:100px"
                            @click="openSupplyDetail()">请选择</el-link>
                        <el-link v-else :underline="false" type="success" @click="openSupplyDetail()">{{
                            formData.detailSupplyName }}</el-link>
                    </el-form-item>
                    </div>
                    <el-form-item prop="initAmount">
                        <span slot="label">期初</span>
                        <el-input v-model="formData.initAmount" type="number" style="width: 215px" 
                            placeholder="请输入">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="dataType == 1">
                        <span slot="label">入库</span>
                        <el-input v-model="formData.inAmount" type="number" style="width: 215px" 
                            placeholder="请输入">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="dataType == 1">
                        <span slot="label">耗用</span>
                        <el-input v-model="formData.actualOutAmount" type="number" style="width: 215px" 
                            placeholder="请输入">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="dataType == 1">
                        <span slot="label">期末</span>
                        <el-input v-model="formData.endAmount" type="number" style="width: 215px" 
                            placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="closeAdd">取 消</el-button>
                <el-button class="bottom_all" style="margin-left: 24px" @click="saveForm()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 明细客商 -->
        <detailSupply ref="detailSupply" :dialog.sync="detailSupplyDialog" :detailRow="detailRow" :saveType="saveType"
            @reset="resetSupply" @setDetail="setDetail" />
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { querymainBodyList, querySupplierAmountShare,saveOrUpdate } from "@/api/docking.js";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";
import detailSupply from "@/views/ShareSystem/components/contract/detailSupply";
export default {
    components: {
        detailSupply
    },
    mixins: [mixin],
    data() {
        return {
            pagesType: 0,
            tableParams: {
                accountDate: "",//日期(必传)
                companyId: "",
                companyName: "",
                stationIds: [],
                modeType: "", //模式（非必传，模式: 1 购买；2委托加工）
            },
            tableDataA: [],
            tableDataB: [],
            mainBodyList: [],
            tableA: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "150" },
                { label: "入库", prop: "inAmount", status: true, width: "150" },
                { label: "理论耗用", prop: "theoryAmount", status: true, width: "150" },
                { label: "实际耗用", prop: "actualOutAmount", status: true, width: "150" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
                { label: "操作", prop: "planNoticeNum", status: true, width: "150" },
            ],
            tableB: [
                { label: "供应商", prop: "supplyName", status: true, width: "auto" },
                { label: "明细供应商", prop: "detailSupplyName", status: true, width: "auto" },
                { label: "期初", prop: "initAmount", status: true, width: "150" },
                { label: "入库", prop: "inAmount", status: true, width: "150" },
                { label: "耗用", prop: "actualOutAmount", status: true, width: "150" },
                { label: "期末(期末+入库-耗用)", prop: "endAmount", status: true, width: "150" },
                { label: "操作", prop: "planNoticeNum", status: true, width: "150" },
            ],
            dataType: 3,//1非最新一期，2最新一期，3账期未生成
            formB: {
                id: "",
                accountDate: "",
                companyId: "",
                companyName: "",
                supplyId: "",
                supplyName: "",
                initAmount: "",
                materialType: "",
                detailSupplyCode: "",
                detailSupplyName: ""
            },
            formA: {
                id: "",
                accountDate: "",
                companyId: "",
                companyName: "",
                supplyId: "",
                supplyName: "",
                initAmount: "",
                inAmount: "",
                actualOutAmount: "",
                endAmount: "",
                materialType: "",
                detailSupplyCode: "",
                detailSupplyName: ""
            },
            formData: {},
            supplierList: [],
            detailSupplyDialog: false,//明细客商
            detailRow: {},
            saveType: "2",
            addDig:false,
            saveload:false,
            formRules: {
                supplyId: [{ required: true, message: "请选择供应商", trigger: "change" }],
                detailSupplyName: [{ required: true, message: "请选择供应商", trigger: "change" }],
                initAmount: [{ required: true, message: "请输入期初", trigger: "blur" }],
      },
        };
    },
    watch: {
    },
    updated(){
    this.$nextTick(() => {
      this.$refs.tableData1.doLayout();
      this.$refs.tableData2.doLayout();
    })
  },
    async created() {
        const res = await querymainBodyList()
        if (res.code == 1001) {
            this.mainBodyList = res.data
            this.init()
        }
        let params = {
            page: 1,
            pageSize: 99999,
            enable: 1.
        };
        querysupplierPage(params).then(res => {
            this.supplierList = res.data.data;
        });
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (index == 1) {
                    sums[index] = '';
                    return
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (Number(prev) + Number(curr)).toFixed(2);
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        closeAdd(){
            this.addDig = false
            this.$refs['formData'].resetFields();
        },
        saveForm(){
            this.$refs['formData'].validate((valid) => {
          if (valid) {
            console.log(this.formData)
            saveOrUpdate(this.formData).then(res => {
                if(res.code == 1001) {
                    this.$message.success('保存成功!')
                    this.closeAdd();
                    this.querySupplierAmountShare();
                }
            })
          } else {
            return false;
          }
        });
        },
        addForm(type){
            if (!this.tableParams.accountDate) {
                this.$message.warning('请选择到账时间!')
                return
            }
            this.formData = {}
            if (this.dataType == 1) {
                this.formData = JSON.parse(JSON.stringify(this.formA))
            } else {
                this.formData = JSON.parse(JSON.stringify(this.formB))
            }
            console.log(this.formData)
            this.formData.materialType = type
            this.formData.companyId = this.tableParams.companyId
            this.formData.companyName = this.tableParams.companyName
            this.formData.accountDate = this.tableParams.accountDate
            this.addDig = true
            
        },
        editForm(row, type) {
            console.log(row)
            this.formData = {}
            if (this.dataType == 1) {
                this.formData = JSON.parse(JSON.stringify(this.formA))
            } else {
                this.formData = JSON.parse(JSON.stringify(this.formB))
            }
            for (const key in this.formData) {
  if (Object.prototype.hasOwnProperty.call(row, key)) {
    this.formData[key] = row[key];
  }
}
this.formData.materialType = type
  this.formData.id = row.id
  this.formData.accountDate = row.accountDate ?row.accountDate: this.tableParams.accountDate
  console.log(this.formData)
  this.addDig = true

        },
        openSupplyDetail() {
            this.detailSupplyDialog = true
            this.$refs.detailSupply.initData();
        },
        resetSupply() {
            this.detailSupplyDialog = false
        },
        setDetail(param) {
            console.log(param)
            this.formData.detailSupplyName = param.profitCsName
            this.formData.detailSupplyCode = param.profitCsCode
            this.resetSupply();
        },
        querySupplierAmountShare() {
            if (!this.tableParams.companyId) {
                this.$message.warning('主体不能为空!')
                return
            }
            if (!this.tableParams.accountDate) {
                this.$message.warning('到账时间不能为空!')
                return
            }
            this.tableLoading = true
            querySupplierAmountShare(this.tableParams).then(res => {
                if (res.code == 1001) {
                    this.tableDataA = res.data.mainMaterialList
                    this.tableDataB = res.data.accessoriesList
                    this.dataType = res.data.type*1
                    console.log(this.dataType)
                }
                this.tableLoading = false
            }).catch(() => {
                this.tableLoading = false
            })
        },
        compareAccountDate() {
            const accountDateStr = this.tableParams.accountDate; // 例如 "2023-06"
            if (!accountDateStr) return null; // 处理空值情况

            // 获取当前年月字符串，格式 "YYYY-MM"
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 月份从0开始，需要+1
            const currentMonthStr = `${currentYear}-${currentMonth.toString().padStart(2, '0')}`;

            if (accountDateStr < currentMonthStr) {
                return 1;
            } else if (accountDateStr === currentMonthStr) {
                return 2;
            } else {
                return 3;
            }
        },
        init() {
            this.tableParams = this.$options.data().tableParams
            this.tableParams.companyId = this.mainBodyList[0].id
            this.tableParams.companyName = this.mainBodyList[0].name
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}</style>
  